export enum NotificationPreferences {
    All = 'Allow all (recommended)',
    TEXT_ONLY = 'Text only',
    EMAIL_ONLY = 'Email only',
}
